var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera_blue",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input",
    fill: "#fff",
    stroke: "#eaecf2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 50,
    height: 50,
    rx: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "photo_camera_black_24dp",
    transform: "translate(13.2 14.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 3.24,
    cy: 3.2,
    rx: 3.24,
    ry: 3.2,
    transform: "translate(7.56 7.467)",
    fill: "#0074d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M21.44,4.133H18.016l-1.339-1.44A2.162,2.162,0,0,0,15.09,2H10.51a2.2,2.2,0,0,0-1.6.693L7.584,4.133H4.16A2.153,2.153,0,0,0,2,6.267v12.8A2.153,2.153,0,0,0,4.16,21.2H21.44a2.153,2.153,0,0,0,2.16-2.133V6.267A2.153,2.153,0,0,0,21.44,4.133ZM12.8,18a5.334,5.334,0,1,1,5.4-5.333A5.369,5.369,0,0,1,12.8,18Z",
    transform: "translate(-2 -2)",
    fill: "#0074d7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraBlue);
export default __webpack_public_path__ + "static/media/camera_blue.8ed4f8d741002b889232ed52695ac7a3.svg";
export { ForwardRef as ReactComponent };